const ERROR_TYPES = {
  STALE_PROMISE: 'STALE_PROMISE',
};

export default ERROR_TYPES;
